import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CrisisDeclarationModal from './CrisisDeclarationModal';

export default function ActiveResponseProcedures() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleStartAssessment = () => {
    navigate('/crisis-response/assessment');
  };

  const handleActivateResponse = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="space-y-6">
      <div className="border-b pb-4">
        <h3 className="text-lg font-medium">Active Response Procedures</h3>
        <div className="mt-4 space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h4 className="font-medium text-yellow-700">Incident Assessment</h4>
            <p className="text-sm text-yellow-600 mt-2">Rapid assessment of ongoing incidents</p>
            <button 
              onClick={handleStartAssessment}
              className="mt-3 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700"
            >
              Start Assessment
            </button>
          </div>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h4 className="font-medium text-red-700">Cyber Crisis Declaration</h4>
            <p className="text-sm text-red-600 mt-2">Initiate Cyber Crisis Management Plan</p>
            <button 
              onClick={handleActivateResponse}
              className="mt-3 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            >
              Activate Response
            </button>
          </div>
        </div>
      </div>
      <CrisisDeclarationModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
}